import {useContext} from 'react';
import {Navbar, NavbarProps} from '@common/ui/navigation/navbar/navbar';
import {SiteConfigContext} from '@common/core/settings/site-config-context';

export function UserCabinetNavbar(props: Omit<NavbarProps, 'menuPosition'>) {
  const {userCabinet} = useContext(SiteConfigContext);

  if (userCabinet?.Navbar) {
    return <userCabinet.Navbar className="flex-shrink-0" {...props} />;
  }

  return (
    <Navbar
      menuPosition="dashboard"
      className="flex-shrink-0"
      {...props}
    />
  );
}
